import { app } from '../../../../app';
import { Controller } from './push-approval-services-form.controller';

app.component('pushApprovalServicesForm', {
    bindings: {
        pushApprovalServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&',
    },
    controller: Controller,
    templateUrl: require('./push-approval-services-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/push-approval-services-form.component.js